import { render, staticRenderFns } from "./_base-header-title.vue?vue&type=template&id=07e27f60&scoped=true"
import script from "./_base-header-title.vue?vue&type=script&lang=js"
export * from "./_base-header-title.vue?vue&type=script&lang=js"
import style0 from "./_base-header-title.vue?vue&type=style&index=0&id=07e27f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e27f60",
  null
  
)

export default component.exports